// extracted by mini-css-extract-plugin
export var container = "_fv-0";
export var content = "_fv-3";
export var customerTitle = "_fv-4";
export var empty = "_fv-5";
export var gray = "_fv-6";
export var header = "_fv-7";
export var info = "_fv-8";
export var loading = "_fv-2";
export var loadingCard = "_fv-9";
export var oneLine = "_fv-a";
export var personName = "_fv-e";
export var pillContainer = "_fv-b";
export var selected = "_fv-1";
export var text = "_fv-c";
export var twoLines = "_fv-d";
export var unread = "_fv-f";
export var unreadIndicator = "_fv-g";